import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { formatErr } from "../lib/api";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const u = await login(email, password);
            toast.success("Welcome back, warrior.");
            if (u.role === "admin") navigate("/admin");
            else if (!u.goal) navigate("/onboarding");
            else navigate("/app");
        } catch (err) {
            toast.error(formatErr(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="app-shell min-h-screen px-6 pt-10 pb-12">
            <Link to="/" className="inline-flex items-center text-zinc-500 hover:text-white" data-testid="back-btn">
                <ArrowLeft size={18} />
                <span className="ml-2 label-cap text-xs">Back</span>
            </Link>

            <div className="mt-10">
                <span className="label-cap text-neon-green text-xs">Re-enter Battle</span>
                <h1 className="font-display font-black text-5xl uppercase tracking-tight mt-2">Log In</h1>
                <p className="text-zinc-400 mt-2">Your streak is waiting.</p>
            </div>

            <form onSubmit={submit} className="mt-10 space-y-4">
                <div>
                    <label className="label-cap text-xs text-zinc-500">Email</label>
                    <input
                        data-testid="login-email"
                        type="email"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full mt-2 bg-charcoal-700 border border-charcoal-500 px-4 py-3 text-white focus:border-neon-orange focus:outline-none"
                    />
                </div>
                <div>
                    <label className="label-cap text-xs text-zinc-500">Password</label>
                    <input
                        data-testid="login-password"
                        type="password"
                        required
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="w-full mt-2 bg-charcoal-700 border border-charcoal-500 px-4 py-3 text-white focus:border-neon-orange focus:outline-none"
                    />
                </div>
                <button
                    data-testid="login-submit"
                    type="submit"
                    disabled={loading}
                    className="btn-primary w-full py-4 text-lg disabled:opacity-50"
                >
                    {loading ? "Entering..." : "Enter The Arena"}
                </button>
            </form>

            <div className="mt-8 text-center">
                <Link to="/register" className="text-zinc-400 hover:text-white text-sm" data-testid="goto-register">
                    No account? <span className="text-neon-green font-bold">Create one</span>
                </Link>
            </div>
        </div>
    );
}
